import { Outlet ,useLocation} from "react-router-dom";
import NavigationRail from "../components/NavigationRail/NavigationRail";
import PageHeader from "../components/PageHeader/PageHeader";
import "./MainLayout.css";

function MainLayout() {
  const location = useLocation();

  const isGIS = location.pathname === "/";
  return (
    <div className="app-layout">

      <PageHeader />

      <NavigationRail />

      <main
          className={`page-content ${
            isGIS ? "gis-page" : "normal-page"
          }`}
        >
          <Outlet />
        </main>

    </div>
  );
}

export default MainLayout;